<div class="h-screen w-screen">
  @if (isVisuAllowed()) {
    <app-data-visu
      [filteringEnabled]="true"
      [isInsidePopup]="true"
      [inPlaceEditingEnabled]="true" />
  }
  <app-entity-auto-complete-host />
  <app-notification-container />
  <app-overlay-host />
</div>
